exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-dialog .el-dialog__body .el-form .el-form-item[data-v-7b330ea1] {\n  margin-bottom: 0;\n}", ""]);

// exports
